import { render, staticRenderFns } from "./NarrationOffIcon.vue?vue&type=template&id=06dd0934&"
import script from "./NarrationOffIcon.vue?vue&type=script&lang=js&"
export * from "./NarrationOffIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports